<div mat-dialog-title class="dialog-info horizontal-padding m-0" closeOnEscape>
    <label class="dialogTitle">
        {{title | translate}}
    </label>
    <button type="button" class="btn-close btn-close-white shadow-none dialogCross" [mat-dialog-close]></button>
</div>
<mat-dialog-content class="horizontal-padding">
    <div [formGroup]="costReviewAddModifyReviewerForm">
        @if(isCostReviewRequest){
        <div class="row m-0 col-sm-12 row-height align-items-baseline justify-content-between">
            <div class="p-0 label-width">
                <label>
                    {{'AVAILABLE' | translate}}
                </label>
            </div>
            <div class="p-0 form-field-width">
                <mat-form-field appearance="outline" class="m-0 col-sm-12">
                    <mat-select formControlName="available" (selectionChange)="onAvailableReviewerChange($event)">
                        @for(role of availableReviewers; track role.reviewUserId){
                        <mat-option class="optionHeight" [value]="role.reviewUserId">
                            {{role.reviewerName}}
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="p-0 verify-button-width"></div>
        </div>
        <hr>
        }

        <div class="row m-0 col-sm-12 row-height align-items-baseline justify-content-between">
            <div class="p-0 label-width">
                <label>
                    {{'ROLE' | translate}}
                </label>
            </div>
            <div class="p-0 form-field-width">
                <mat-form-field appearance="outline" class="m-0 col-sm-12">
                    @if(!isModifyMode){
                    <mat-select formControlName="role" (selectionChange)="onRoleChange($event)">
                        @for(role of visibleReviewerRoles; track role.id){
                        <mat-option class="optionHeight" [value]="role.id">
                            {{role.description}}
                        </mat-option>
                        }
                    </mat-select>
                    }
                    @else {
                    <input matInput [value]="selectedReviewerRoleDescription" readonly>
                    }
                </mat-form-field>
            </div>
            <div class="p-0 verify-button-width"></div>
        </div>
        <div class="row m-0 col-sm-12 row-height align-items-baseline justify-content-between">
            <div class="p-0 label-width">
                <label>
                    {{'REVIEW_CANCEL_DIALOG_NAME'| translate}}
                </label>
            </div>
            <div class="p-0 form-field-width">
                <mat-form-field appearance="outline" class="m-0 col-sm-12">
                    <input matInput formControlName="name">
                </mat-form-field>
            </div>
            <div class="p-0 verify-button-width"></div>
        </div>
        <div class="row m-0 col-sm-12 row-height align-items-baseline justify-content-between">
            <div class="p-0 label-width">
                <label>
                    {{'REVIEW_CANCEL_DIALOG_EMAIL'| translate}}
                </label>
            </div>
            <div class="p-0 form-field-width">
                <mat-form-field appearance="outline" class="m-0 col-sm-12">
                    <input matInput formControlName="email">
                </mat-form-field>
            </div>
            <div class="row m-0 p-0 justify-content-end verify-button-width">
                <button mat-raised-button color="primary" class="col-sm-12 p-0" [disabled]="isVerifyDisabled"
                    (click)="onVerifyClick()">
                    {{'VERIFY_BTN_LABEL'| translate}}
                </button>
            </div>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end" class="dialog-actions-style">
    @if(!isModifyMode){
    <button mat-raised-button color="primary" (click)="onAdd()" [disabled]="isAddDisabled">
        {{'OK' | translate}}
    </button>
    }
    @else {
    <button mat-raised-button color="primary" class="button-padding" (click)="onUpdateClick()"
        [disabled]="isUpdateDisabled">
        {{'UPDATE' | translate}}
    </button>
    }
    <button mat-raised-button color="warn" class="button-padding" mat-dialog-close>
        {{'CANCEL_BTN_LABEL' | translate}}
    </button>
</mat-dialog-actions>